import React, {useContext, useMemo} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MenuButton } from "react-md";
import { Link } from "react-router-dom";
import ListItem from "react-md/lib/Lists/ListItem";
import Avatar from "react-md/lib/Avatars";
import { userLogout } from "actions/user";
import context from "components/Shared/MSidebar/utility/context";
import WebConfig from "middlewares/WebConfig";
import { WindowContext } from "components/Shared/WindowProvider.tsx";

const DrawerFooter = ({
  user: {firstName, lastName, username},
  dispatch
}) => {
  const {open} = useContext(context);
  const classname = useMemo(
    () => open ? "DrawerFooter-Name-Visisble" : "DrawerFooter-Name-Hidden",
    [open]
  );

  let menuItems = [
    <Link key="profile" to="/profile" data-test="profile"> <ListItem primaryText="My Profile" /> </Link>,
    <Link key="change-pw" to="/change-password" data-test="change-password"> <ListItem primaryText="Change Password" /> </Link>,
    <div key="logout" onClick={() => dispatch(userLogout())} data-test="logout"> <ListItem primaryText="Logout"/> </div>,
  ];

  if (WebConfig.environment === "testing" || WebConfig.environment === "development") {
      const windowProvider = useContext(WindowContext);
      menuItems.splice(2, 0, <div key="new-window" onClick={() => windowProvider.openNewWindowWithSSO("", { openInNewTab: true })} data-test="new-window"> <ListItem primaryText="New Window"/> </div>);
  }

  return (
    <div className={"DrawerFooter-Root"}>
      <MenuButton
        id={"DrawerFooter"}
        menuItems={menuItems}
        position={MenuButton.Positions.BOTTOM_LEFT}
        anchor={{
          x: MenuButton.HorizontalAnchors.CENTER,
          y: MenuButton.VerticalAnchors.BOTTOM,
        }}
        simplifiedMenu={false}
        repositionOnScroll={false}
        flat
      >
        <div className={"DrawerFooter-Contents"}>
          <Avatar className={"DrawerFooter-Avatar"} data-test="avatar">
            {(firstName || username).toUpperCase().charAt(0)}
          </Avatar>
          <div className={`DrawerFooter-Name ${classname}`}>
            {(firstName && lastName)
              ? `${firstName} ${lastName}`
              : username
            }
          </div>
        </div>
      </MenuButton>
    </div>
  );
};

DrawerFooter.propTypes = {
  user: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect(
  state => ({
    user: state.user.profile,
  }),
  dispatch => ({
    dispatch,
  })
)(DrawerFooter);